import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading } from '../../components';

import css from './ListingPage.module.css';

/**
 * Shows parcel dimensions on the public listing page so buyers know the
 * item's physical footprint (length × width × height, weight) before they
 * head to checkout. Source: `publicData.shippingDimensions` written by
 * the seller on `/edit/delivery`. Rendered only when the listing is
 * shipping-enabled AND all four numeric fields are present - matches the
 * gating in `EditListingDeliveryPanel`.
 */
const SectionShippingDetailsMaybe = props => {
  const { publicData, className, rootClassName } = props;
  if (!publicData || !publicData.shippingEnabled) return null;

  const dims = publicData.shippingDimensions || {};
  const { length, width, height, weight, distanceUnit = 'in', massUnit = 'oz' } = dims;
  const hasFullDims =
    Number(length) > 0 && Number(width) > 0 && Number(height) > 0 && Number(weight) > 0;
  if (!hasFullDims) return null;

  const classes = classNames(rootClassName || css.sectionDetails, className);
  return (
    <section className={classes}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="SectionShippingDetailsMaybe.heading" />
      </Heading>
      <p className={css.shippingNote}>
        <FormattedMessage id="SectionShippingDetailsMaybe.calculatedAtCheckoutNote" />
      </p>
      <ul className={css.details}>
        <li className={css.detailsRow}>
          <span className={css.detailLabel}>
            <FormattedMessage id="SectionShippingDetailsMaybe.dimensionsLabel" />
          </span>
          <span className={css.detailValue}>
            {length} × {width} × {height} {distanceUnit}
          </span>
        </li>
        <li className={css.detailsRow}>
          <span className={css.detailLabel}>
            <FormattedMessage id="SectionShippingDetailsMaybe.weightLabel" />
          </span>
          <span className={css.detailValue}>
            {weight} {massUnit}
          </span>
        </li>
      </ul>
    </section>
  );
};

export default SectionShippingDetailsMaybe;
